import React from 'react';
import styled from 'styled-components';
import {Button} from '@betareader/design-system';
import {push} from '../../navigation';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {withTranslation} from 'react-i18next';
import {withRouter} from 'react-router-dom';

import {toggleBrowseMenu} from '../../modules/app';
import genres from '../../shared/constants/genres';
import uxAnalyticsUtil from '../../utils/uxAnalyticsUtil';
import GenreGrid from './genreGrid';

const BrowseWrap = styled.div`
  position: relative;
`;

const BrowsePanel = styled.div`
  background: var(--br-surface);
  border: 1px solid var(--br-border);
  border-radius: var(--br-control-radius);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.18);
  color: var(--br-text);
  left: 0;
  max-height: 70vh;
  overflow: auto;
  padding: var(--br-space-3);
  position: absolute;
  top: 100%;
  width: min(680px, calc(100vw - 2rem));
  z-index: 100;

  @media (max-width: 600px) {
    border-radius: 0;
    left: 0;
    max-height: calc(100vh - 40px);
    position: fixed;
    top: 40px;
    width: 100vw;
  }
`;

export const Browse = ({showBrowseMenu, t, toggleBrowseMenu}) => {
  const toggle = () => {
    if (!showBrowseMenu) {
      uxAnalyticsUtil.trackEvent({category: 'Discover', action: 'clicked-browse', label: 'browse'});
    }
    toggleBrowseMenu(!showBrowseMenu);
  };
  const close = () => toggleBrowseMenu(false);

  return (
    <BrowseWrap>
      <Button variant='ghost' aria-expanded={Boolean(showBrowseMenu)}
        aria-controls='browse-genres' onClick={toggle}>
        {t('Browse')}
      </Button>
      {showBrowseMenu && (
        <BrowsePanel id='browse-genres' role='region' aria-label={t('Browse')}>
          <GenreGrid genres={genres} onClose={close} />
        </BrowsePanel>
      )}
    </BrowseWrap>
  );
};

const mapStateToProps = state => ({
  showBrowseMenu: state.app.showBrowseMenu,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  toggleBrowseMenu,
  changePage: newPage => push(newPage),
}, dispatch);

export default withTranslation()(withRouter(connect(mapStateToProps, mapDispatchToProps)(Browse)));
